var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "edit_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#edit_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M5.154 19H6.39l9.26-9.26-1.236-1.236-9.26 9.26V19ZM18.858 8.656l-3.375-3.344 1.313-1.314c.287-.287.641-.43 1.062-.43.42 0 .774.143 1.061.43l1.237 1.237c.287.287.436.636.446 1.046.01.41-.128.759-.416 1.046l-1.328 1.329ZM4.558 20.5a.876.876 0 0 1-.645-.259.876.876 0 0 1-.26-.645v-2.094a.905.905 0 0 1 .271-.648L14.4 6.38l3.375 3.375L7.3 20.229a.906.906 0 0 1-.304.206.918.918 0 0 1-.344.065H4.558Z",
    fill: "currentColor"
  }))));
};
export default SvgEdit;